import { InactivityPinFormValues } from "./VerifyPinForm.interface";

export const PIN_LENGTH = 6;
export const BACKSPACE_KEY = "Backspace";
export const ARROW_LEFT_KEY = "ArrowLeft";
export const ARROW_RIGHT_KEY = "ArrowRight";
export const pinFields: (keyof InactivityPinFormValues)[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f"
];

export const dobPlaceholders: Record<number, string> = {
  0: "d",
  1: "d",
  2: "m",
  3: "m",
  4: "y",
  5: "y"
};
